import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';

const DiskUsageAlert = ({ alertState = '', handleClick = () => {} }) => {
  const { t } = useTranslation('hosting');

  if (alertState === '') return null;

  return (
    <Alert
      data-testid="alert-banner"
      severity={alertState === 'critical' ? 'error' : 'warning'}
      action={
        <Button
          onClick={handleClick}
          variant="outlined"
          sx={{
            color: alertState === 'critical' ? 'error.dark' : 'warning.dark',
          }}
        >
          {t('hosting:renewal.alerts.diskUsageAlert.ctaText')}
        </Button>
      }
      sx={{
        alignItems: 'center',
        pl: 1,
        py: 1,
      }}
    >
      {(alertState === 'alert' || alertState === 'warning') && (
        <AlertTitle sx={{ color: 'common.black' }}>
          {t(`renewal.alerts.diskUsageAlert.warning`)}
        </AlertTitle>
      )}
      {alertState === 'critical' && (
        <AlertTitle sx={{ color: 'common.black' }}>
          {t(`renewal.alerts.diskUsageAlert.critical`)}
        </AlertTitle>
      )}
    </Alert>
  );
};

export default DiskUsageAlert;
